import {Grid} from '@logistics-frontend/blocks'
import {range} from '@logistics-frontend/utils'
import React from 'react'

import {StoriesBarSegment} from './stories-bar-segment'

type Props = {
  storiesAmount: number
  currentStoryId: number
  onClick: (nextStoryId: number) => void
}

export const StoriesBar: React.FC<Props> = ({storiesAmount, currentStoryId, onClick}) => {
  return (
    <Grid size="xs" wrap="nowrap" container>
      {range(0, storiesAmount).map(i => (
        <Grid key={i} xs={12} item>
          <StoriesBarSegment
            isLoaded={currentStoryId > i}
            isLoading={currentStoryId === i}
            onClick={() => {
              onClick(i)
            }}
          />
        </Grid>
      ))}
    </Grid>
  )
}
